import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ClassificationsService } from '../commonServices/classifications.service';

export const classificationsResolver: ResolveFn<any> = (route, state) => {
  return inject(ClassificationsService).get();
};
